import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import {
  BodyText,
  Button,
  CaptionText,
  HeadingText,
  LockIcon,
} from '@paypalcorp/pp-react';
import resolve from '../../services/route.service';
import routes from '../../routes';
import constants from '../../constants';
import OpenBankIconComponent from '../common/open-banking-icon';
import './open-banking-choice.less';
import { trackClick, trackPage } from '../../utils/fpti-helper';

const OpenBankingChoiceComponent = ({ country, groupName, opportunityId }) => {
  useEffect(() => {
    trackPage({
      page: 'CustomerChoice',
      eventName: 'pageLoad',
    });

    return () => {
      trackPage({
        page: 'CustomerChoice',
        eventName: 'pageUnload',
      });
    };
  }, []);

  return (
    <>
      <div div="open-banking-choice-component" className="open-banking-choice-style">
        <div className="open-banking-choice-container">
          <div id="bank-icon-container" className="bank-icon-style">
            <OpenBankIconComponent />
          </div>

          <HeadingText size="sm">
            {constants.openBanking.openBankingChoiceTitleText}
          </HeadingText>
          <BodyText>
            {constants.openBanking.openBankingChoiceBodyText}
          </BodyText>
          <div
            id="caption-text-with-icon"
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '12px',
            }}
          >
            <LockIcon />
            <CaptionText strong>
              {constants.openBanking.openBankingChoiceCaptionText}
            </CaptionText>
          </div>

        </div>

        <div
          id="grouped-btn-container"
          style={{
            display: 'flex',
            alignItems: 'center',
            flexDirection: 'column',
            justifyContent: 'center',
            gap: '.5rem',
            marginTop: '3.75rem',
          }}
        >
          <Button
            type="button"
            as={Link}
            onClick={() => trackClick({ page: 'CustomerChoice', eventName: 'openBankingSelected' })}
            to={resolve(routes['upload-document-open-banking'].path, {
              country,
              opportunityId,
              groupName,
            })}
          >
            {constants.openBanking.openBankingChoicePrimaryBtnText}
          </Button>
          <Button
            type="button"
            as={Link}
            secondary
            onClick={() => trackClick({ page: 'CustomerChoice', eventName: 'manualUploadSelected' })}
            to={resolve(routes['upload-document-group'].path, {
              country,
              opportunityId,
              groupName,
            })}
          >
            {constants.openBanking.openBankingChoiceSecondaryBtnText}
          </Button>
        </div>
      </div>

    </>
  );
};

OpenBankingChoiceComponent.propTypes = {
  country: PropTypes.string.isRequired,
  groupName: PropTypes.string.isRequired,
  opportunityId: PropTypes.string.isRequired,
};
export default OpenBankingChoiceComponent;
